export default __webpack_public_path__ + "static/media/appletv-new.ab2be28b.png";